//#region Imports
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeProviderWrapper } from "./style/Theme Provider Wrapper";
import "./style/index.scss";

import { Provider } from "react-redux";
import { store } from "./store/store";
import ErrorBoundary, {
  ErrorPage,
} from "./additional/components/Error Boundary";

import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
  BrowserRouter,
} from "react-router-dom";

import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from "@grafana/faro-react";
//#endregion

initializeFaro({
  url: `${import.meta.env.VITE_GRAFANA_URL}faro/collect`,
  app: {
    name: "frontend",
    version: "1.0.0",
  },
  instrumentations: [
    ...getWebInstrumentations(),

    new ReactIntegration({
      router: createReactRouterV6Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType,
      }),
    }),
  ],
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProviderWrapper>
      <BrowserRouter>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Provider store={store}>
            <App />
          </Provider>
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProviderWrapper>
  </StrictMode>
);
